import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { PATH_EDUCACAO_SEDUC_DOMINIOS_API } from 'services/rotasp/path';
import { ApiResponse, getApi } from 'services/rotasp/api';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types } from './types';

import { tiposIndigenasSuccess, tiposIndigenasFailure } from './actions';

function* module(request: ReducerActionRotaSP) {
	const { token, payload }: { token?: string; payload: {} } = request;
	const response: ApiResponse = yield call(
		getApi,
		token || '',
		PATH_EDUCACAO_SEDUC_DOMINIOS_API,
		`povos-indigenas`,
		payload,
	);
	if (response.status === 200) {
		yield put(tiposIndigenasSuccess(response));
	} else if (response.error) {
		yield put(tiposIndigenasFailure(response.message));
	}
}

export default all([takeLatest(Types.TIPOS_INDIGENAS_REQUEST, module)]);
